import React, { useState } from "react";
import DTOAirTickets from "./DTOAirTickets";
import AirTikcetsPresenter from "./AirTikcetsPresenter";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function AirTicketsController() {
  const { t } = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.airTicketsSlice.airticketLoader
  );
  const [allAirTickets, setAllAirTickets] = useState([]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function callBackFunc(data: any) {
    setAllAirTickets(data);
  }

  return (
    <>
      <DTOAirTickets setAirTicketsData={callBackFunc} />
      <AirTikcetsPresenter
        airTicketsData={allAirTickets}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default AirTicketsController;
